import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-generate-bill',
  templateUrl: './generate-bill.component.html',
  styleUrls: ['./generate-bill.component.scss']
})
export class GenerateBillComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
